import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageBreeds,
  PageBreed,
} from '../pages/breeds';

const RouteBreeds = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageBreeds />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageBreed />
      </Route>
    </Switch>
  );
};

export default RouteBreeds;
